<template>
  <a-modal width="800px" v-model="visible" title="新增客户" :maskClosable="false" @ok="handleOk"
    :confirmLoading="confirmLoading" @cancel="handleClose" :bodyStyle="{ padding: '10px' }">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-card title="基本信息" :bordered="false">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="客户姓名" prop="customer_name">
              <a-input v-model="form.customer_name" placeholder="请输入客户姓名" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="客户手机号" prop="customer_phone">
              <a-input v-model="form.customer_phone" placeholder="请输入客户手机号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="身份证号" prop="id_no">
              <a-input v-model="form.id_no" placeholder="请输入客户身份证号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="微信号" prop="wechart_account">
              <a-input v-model="form.wechart_account" placeholder="请输入微信号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="客户住址" prop="customer_address">
              <a-input v-model="form.customer_address" placeholder="请输入客户住址" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="性别" prop="gender">
              <a-radio-group v-model="form.gender">
                <a-radio value="1"> 男 </a-radio>
                <a-radio value="2"> 女 </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="会员信息" :bordered="false">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="会员级别" prop="vip">
              <!-- <a-input-group compact> -->
              <a-select v-model="form.vip" allowClear style="width: 100%" placeholder="请选择" @change="changeVip">
                <a-select-option v-for="v in vipList" :key="v.vip_name" :value="v.vip_id" :label="v.vip_name">
                  {{ v.vip_name }}({{ v.vip_price }})
                </a-select-option>
              </a-select>
              <!-- <a-input style="width: 35%" allowClear v-model="form.vip_grade" placeholder="输入等级"></a-input> -->
              <!-- <a-input-number :formatter="value => `V ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/V\s?|(,*)/g, '')" style="width: 35%" v-model="form.vip_grade" :min="0"
            :step="1" placeholder="输入等级" /> -->
              <!-- </a-input-group> -->
            </a-form-model-item>
            <a-form-model-item :label="'缴费收款账户'" prop="account_id">
              <a-select v-model="form.account_id"  show-search :filter-option="filterOption" placeholder="请选择" style="width: 100%">
                <a-select-option v-for="item in accountList" :key="item.account_id" :value="item.account_id">
                  {{ item.account_name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="缴费金额" prop="vip_price">
              <a-input-number v-model="form.vip_price" :min="0" :step="0.01" style="width: 100%"
                placeholder="请输入会员加入时缴费金额" />
            </a-form-model-item>
            <a-form-model-item label="共享员工">
              <a-input-group compact>
                <a-select show-search allowClear :maxTagCount="1" v-model="form.share_list" mode="multiple"
                  style="width: 100%" placeholder="想要共享的同事" :filter-option="filterOption">
                  <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                    {{ v.real_name }}
                    <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                      ({{ v.department.department_name }})
                    </span>
                  </a-select-option>
                </a-select>
              </a-input-group>
            </a-form-model-item>
            <a-form-model-item label="运营人员" prop="op_userid">
              <a-input-group compact>
                <!-- <a-input style="width: 30%" v-model="form.op_name" placeholder="运营身份描述"></a-input> -->
                <a-select show-search v-model="form.op_userid" style="width: 100%" placeholder="选择人员"
                  :filter-option="filterOption">
                  <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                    {{ v.real_name }}
                    <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                      ({{ v.department.department_name }})
                    </span>
                  </a-select-option>
                </a-select>
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="缴费时间" prop="pay_time">
              <a-date-picker v-model="form.pay_time" show-time style="width: 100%" placeholder="请选择缴费(入会)时间" />
            </a-form-model-item>
            <a-form-model-item label="入会权益" prop="vip_benefit">
              <a-textarea v-model="form.vip_benefit" placeholder="请输入会员入会给予的权益或福利"
                :auto-size="{ minRows: 2, maxRows: 5 }" />
            </a-form-model-item>
            <a-form-model-item label="签署会员合同" prop="contract">
              <a-select v-model="form.contract" placeholder="请选择是否签署会员合同" allowClear>
                <a-select-option value="1"> 已签署 </a-select-option>
                <a-select-option value="2"> 未签署 </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="客户备注" prop="remark">
              <a-textarea v-model="form.remark" placeholder="请输入客户备注" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-card>
      <!-- <a-form-model-item label="重要程度" prop="wechart_account">
        <a-select v-model="form.grade" placeholder="请选择客户重要程度" allowClear>
          <a-select-option value="A"> A级 </a-select-option>
          <a-select-option value="B"> B级 </a-select-option>
          <a-select-option value="C"> C级 </a-select-option>
          <a-select-option value="D"> D级 </a-select-option>
        </a-select>
      </a-form-model-item> -->
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        customer_id: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        gender: "1",
        id_no: "",
        account_id: undefined,
        wechart_account: "",
        vip: undefined,
        contract: undefined,
        grade: undefined,
        remark: "",
        vip_price: null,//vip价格
        pay_time: null,
        op_name: "运营",
        op_userid: undefined,
        vip_grade: "",
        vip_benefit: "",//入会权益
        share_list: []
      },
      accountList: [],
      rules: {
        customer_name: {
          required: true,
          message: "请输入客户姓名",
          trigger: "change",
        },
        customer_phone: [
          {
            required: true,
            message: "请输入客户手机号",
            trigger: "change",
          },
          {
            pattern: /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/,
            message: "请输入有效的大陆、港澳台手机号",
            trigger: "change",
          },
        ],
        op_userid: {
          required: true,
          message: "请选择运营人员",
          trigger: "change",
        },
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      userList: [],
      vipList: []
    };
  },
  methods: {
    init(customer_id) {
      this.visible = true;
      this.customer_id = customer_id;
      if (customer_id) {
        this.getDetail();
      }
      this.getUserList()
      this.getVipList()
      this.getAccountList()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeVip(e) {
      const a = this.vipList.find(v => v.vip_name == e)
      this.form.vip_price = a.vip_price
      this.form.vip_benefit = a.benefit
    },
    getAccountList() {
      this.$http({
        url: "/admin/account/select",
        method: "get",
      }).then(res => {
        this.accountList = res.data
      })
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    getVipList() {
      this.$http({
        url: "/admin/viplist/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.vipList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.customer_id
              ? "/admin/customer/update"
              : "/admin/customer/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(
                this.form.customer_id ? "修改客户成功" : "新增客户成功"
              );
              this.handleClose();
              this.$emit("ok");
            })
            .catch(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
      this.confirmLoading = false;
    },
  },
};
</script>

<style></style>